import React, { Fragment } from 'react';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { AuthenticationResult, EventType, InteractionType, PublicClientApplication, SsoSilentRequest } from '@azure/msal-browser'

const publicClientApp = new PublicClientApplication({
	auth: {
		authority: process.env.REACT_APP_AUTHORIRTY,
		clientId: process.env.REACT_APP_CLIENT_ID || ""
	}
});
publicClientApp.addEventCallback(message => {
	if (message.eventType == EventType.LOGIN_SUCCESS) {
		const result = message.payload as AuthenticationResult;
		if (result)
			publicClientApp.setActiveAccount(result.account);
	}
});

export const getActiveAccount = () => publicClientApp.getActiveAccount();

export const getAccessToken = async (): Promise<string | null> => {
	const clientId = process.env.REACT_APP_CLIENT_ID;

	if (clientId) {
		const result = await publicClientApp.acquireTokenSilent({
			scopes: [`api://${clientId}/Management`]
		});

		if (result && result.accessToken)
			return result.accessToken;
	}
	return '';
};

export const Authenticate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	if (!process.env.REACT_APP_AUTHORIRTY)
		return <Fragment>{children}</Fragment>;
	else
		return (
			<MsalProvider instance={publicClientApp}>
				<MsalAuthenticationTemplate interactionType={InteractionType.Popup}>
					{children}
				</MsalAuthenticationTemplate>
			</MsalProvider>
		);
};